<template lang="pug">
    div
      gp-filter-top#filtersFixed(@getData="getPromotionsItems" :type="'promotions'")
      v-container.gastroprice-content.with-menu.d-flex.flex-column(fluid)
        .block-content.row.flex-nowrap
          v-col(v-if="isLoading" cols="12")
            v-skeleton-loader.mr-9(type="table")
          v-col(v-if="!isLoading" cols="12")
            #scrollHorizontal
              .d-flex.mt-2.pb-0
                  .col-item.mr-4(v-if="data.brand")
                    .head.d-flex.h-full
                      v-col.d-flex.align-center.border-col-rigth(cols="12")
                  template(v-if="data.competitors")
                    .col-item.mr-4(v-for="itemCompetitors in data.competitors" :key="itemCompetitors.id")
                      .head.d-flex
                        v-col.d-flex.align-center.border-col-rigth(cols="12")
            #headBrand
              .d-flex.mt-0.pb-0
                  .col-item.mr-4(v-if="data.brand")
                    .head.d-flex
                      v-col.d-flex.align-center.border-col-rigth(cols="12")
                        img.img-brand.pr-2(:src="data.brand.logo")
                        span.name-brand {{data.brand.name}}
                  template(v-if="data.competitors")
                    .col-item.mr-4(v-for="itemCompetitors in data.competitors" :key="itemCompetitors.id")
                      div(v-if="isLoadingPromo(itemCompetitors.id)")
                        v-skeleton-loader(type="table-heading")
                      .head.d-flex(v-else)
                        v-col.d-flex.align-center.border-col-rigth(cols="12")
                          img.img-brand.pr-2(:src="itemCompetitors.logo")
                          span.name-brand {{itemCompetitors.name}}
            #body
              .d-flex.mt-0.pb-4
                .col-item.mr-4(v-if="data.brand")
                  .row-content.borderSeparatorPromotions(v-for="(item, index) in data.brand.table")
                    promo-collapse(
                      :is-collapse="isCollapse(data.brand.id, item.unique_id)"
                      :item="item"
                      @collapsePromo="collapsePromo(data.brand.id, item.unique_id)"
                      @showDetailsMenuItem="itemMenu => showDetailsMenuItem(data.brand.id, data.brand.name, itemMenu, item)"
                    )
                template(v-if="data.competitors")
                  .col-item.mr-4(v-if="data.competitors" v-for="itemCompetitors in data.competitors" :key="itemCompetitors.id")
                    div.px-5(v-if="isLoadingPromo(itemCompetitors.id)")
                      v-skeleton-loader(type="table-cell@6")
                    div(v-else)
                      .row-content.borderSeparatorPromotions(v-for="(item, index) in itemCompetitors.table")
                        promo-collapse(
                          :is-collapse="isCollapse(itemCompetitors.id, item.unique_id)"
                          :item="item"
                          :is-competitor="true"
                          @collapsePromo="collapsePromo(itemCompetitors.id, item.unique_id)"
                          @showDetailsMenuItem="itemMenu => showDetailsMenuItem(itemCompetitors.id, itemCompetitors.name, itemMenu, item)"
                        )
          v-dialog( v-model="dialog"
            hide-overlay
            width="1100")
              v-card
                v-card-text.pb-0
                  v-container.pt-12
                    img.close-modal.cursor-pointer(:src="img.close" @click="dialog=false")
                    v-row
                      v-col(cols="12")
                        .row
                          v-col(cols="4")
                            translate.black--text Promotion
                            span.ml-4.primary--text.font-weight-med {{infoModal.namePromotion}}
                          v-col(cols="4")
                            translate.black--text Brand
                            span.ml-4.primary--text.font-weight-med {{infoModal.brand}}
                          v-col(cols="4")
                            translate.black--text Average Price
                            span.ml-4.primary--text.font-weight-med {{ infoModal.price | formatNumber(2,2) }} €
                          v-col(cols="4")
                            span.primary--text
                              span {{infoModal.centers}}
                              translate.black--text restaurants
                          v-col(cols="4")
                            translate.black--text Aggregator
                            span.ml-4.primary--text.font-weight-med {{infoModal.aggregator}}

                #tableHistorial.scrollYCustom
                  div
                    .header.row
                      v-col.border-col-rigth.pt-3.pb-3(cols="3")
                        translate Restaurant
                      v-col.border-col-rigth.pt-3.pb-3(cols="2")
                        translate Direction
                      v-col.border-col-rigth.pt-3.pb-3(cols="2")
                        translate Locality
                      v-col.border-col-rigth.pt-3.pb-3(cols="2")
                        translate Province
                      v-col.border-col-rigth.pt-3.pb-3
                        translate Code Postal
                      v-col.border-col-rigth.pt-3.pb-3.text-center
                        translate Price
                    div.container.pr-0.pl-0(v-if="dataModal && dataModal.table")
                      .row.border-b-gray(v-for="(row, i) in dataModal.table.rows"  :class="{'bg-ligth-gray': i % 2 != 0}")
                        v-col.align-center.border-col-rigth(cols="3")
                          span {{ row[0] }}
                        v-col.align-center.border-col-rigth(cols="2")
                          span {{ row[1] }}
                        v-col.align-center.border-col-rigth(cols="2")
                          span {{ row[2] }}
                        v-col.align-center.border-col-rigth(cols="2")
                          span {{ row[3] }}
                        v-col.align-center.border-col-rigth.text-center
                          span {{ row[4] }}
                        v-col.align-center.border-col-rigth.text-center
                          strong {{ row[5] | formatNumber(2,2) }} €

</template>

<script>
import GpFilterTop from '@/components/filters/filter-top.vue'
import SrvGastroPricing from '@/services/gastropricing.js'
import PromoCollapse from "@/components/gastropricing/PromoCollapse.vue"
import collapseMixins from "@/mixins/collapse.js"

export default {
  components: {GpFilterTop, PromoCollapse},
  name: 'promoComparator',
  mixins: [collapseMixins],
  data() {
    return {
      data: {},
      dataModal: [],
      infoModal: {},
      img:{
        close: require('@/assets/img/plus.png')
      },
      dialog: false,
      collapsedPromotions: {},
      loadingPromo: {}
    }
  },
  created(){
  },
  computed: {
    isLoading(){
      return this.$store.getters.isLoading
    }
  },
  methods: {
    getImageAggregator(aggregator){
      let aggregatorLoweCase = aggregator.toLowerCase()
      if(aggregatorLoweCase === 'deliveroo'){
        return require("@/assets/img/aggregators/Deliveroo.png")
      } else if (aggregatorLoweCase === "glovo"){
        return require("@/assets/img/aggregators/Glovo.png")
      } else if (aggregatorLoweCase === "just eat"){
        return require("@/assets/img/aggregators/Just Eat.png")
      } else if (aggregatorLoweCase === "uber eats"){
        return require("@/assets/img/aggregators/Uber Eats.png")
      }
    },
    async getCompetitors(competitorsId, filters) {
      competitorsId.forEach((id, index) => {
        SrvGastroPricing.getPromotionsItems(id, filters)
        .then(res => {
          this.$set(this.data.competitors, index, res.data.brand);
        })
        .finally(() => {
          this.$set(this.loadingPromo, id, false);
        })
      })
    },
    getPromotionsItems(data){
      this.$store.commit('LOADING', true)
      SrvGastroPricing.getPromotionsItems(data.brand, data.filters)
      .then(async(res) => {
          if (res.status === 200) {
            const {competitor_ids, brand} = res.data
            this.data = {
              brand,
              competitors: competitor_ids.map(competitorId => ({id: competitorId}))
            }
            this.$store.commit('LOADING', false)
            this.$nextTick(() =>{
              let s1 = document.querySelector('.body-promoComparator #scrollHorizontal');
              let s2 = document.querySelector('.body-promoComparator #headBrand');
              let s3 = document.querySelector('.body-promoComparator #body');
              if(s1 && s2 && s3) {
                s3.style = 'margin-top: ' + (s2.offsetHeight + 8) + 'px !important;'
                s1.addEventListener('scroll', function () {
                    s2.scrollLeft = s1.scrollLeft
                    s3.scrollLeft = s1.scrollLeft
                });
                // s2.addEventListener('scroll', select_scroll_2, false);
                s1.setAttribute('style','width:'+s3.offsetWidth+'px')
                s2.setAttribute('style','width:'+s3.offsetWidth+'px')
              }

            })
            this.getCompetitors(competitor_ids, data.filters);
          }
        }).catch(() => {
          // this.message = 'Se ha producido un error. Intentelo más tarde.'
          this.$store.commit('LOADING', false)
        })
    },
    showDetailsMenuItem(brand, brandName, menu, promotion){
      this.infoModal.namePromotion = promotion.promo
      this.infoModal.brand = brandName
      this.infoModal.centers = menu.n_centers
      this.infoModal.price = menu.price
      this.infoModal.aggregator = promotion.delivery_platform
      let province = this.$store.getters.hasProvince
      let city = this.$store.getters.hasCity
      SrvGastroPricing.getPromotionsItemModalData(brand,menu.id, promotion.delivery_platform_id, promotion.promo,'',province, city)
        .then(res => {
            if (res.status === 200) {
              this.$store.commit('LOADING', false)
              this.dataModal = res.data
              this.dialog = true
            }
          }, () => {
            // this.message = 'Se ha producido un error. Intentelo más tarde.'
          })
    },
    isLoadingPromo(competitorId){
      const isLoading = this.loadingPromo[competitorId] == undefined ? true :
      this.loadingPromo[competitorId];

      return isLoading;
    }
  },
  mounted () {
    this.$nextTick(() =>{
      let elementBody = document.querySelector('.body-promoComparator .gastroprice-content')
      elementBody.setAttribute('style','padding-top:'+ (document.getElementById('filtersFixed').offsetHeight - 2) + 'px;')
      window.addEventListener('resize', function () {
        let elementBody = document.querySelector('.body-promoComparator .gastroprice-content')
        if (elementBody) {
          elementBody.setAttribute('style','padding-top:'+ (document.getElementById('filtersFixed').offsetHeight - 2) + 'px;')
        }
        let s1 = document.querySelector('.body-promoComparator #scrollHorizontal')
        let s2 = document.querySelector('.body-promoComparator #headBrand')
        let s3 = document.querySelector('.body-promoComparator #body')
        if (s1 && s2 && s3) {
          s1.setAttribute('style','width:'+s3.offsetWidth+'px')
          s2.setAttribute('style','width:'+s3.offsetWidth+'px')
        }
      })
    })
  }
}
</script>
<style lang="scss" scoped>
// scrollbar TOP
#scrollHorizontal{
  position: fixed;
  padding-top:0;
  z-index: 2;
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
  scrollbar-color: #498FE1 #e1e1e1;
  .col-item{
    background-color: transparent;
    border:none;
    border-radius: 0;
    height: 0;
  }
    //SCROLL
  &::-webkit-scrollbar {
    width: 6px;
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: #498FE1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:active {
    background-color: #498FE1;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #498FE1;
    box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.2);
  }
  &::-webkit-scrollbar-track {
    background: #e1e1e1;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-track:hover{
    background: #E6EAF0;
  }
  &::-webkit-scrollbar-track:active {
    background: #E6EAF0;
  }
}
.borderSeparatorPromotions{
  border-bottom:1px solid #707070;
}
#body{
  overflow: hidden;
  .v-skeleton-loader {
    ::v-deep .v-skeleton-loader__table-cell {
      width: 100%;
    }
  }
}
#headBrand{
  padding-top: 28px;
  background-color: #f2f2f2;
  position: fixed;
  width: 85%;
  display: flex;
  overflow: hidden;
  margin-top: -2px;
  z-index: 1;
  .mr-4:last-child{
    margin-right: 0 !important;
  }
}
.col-item{
  width: 366px;
  min-width: 366px;
  background-color: #fff;
  border: 1px solid #D9DFE8;
  border-radius: 5px;
  .head{
    border-bottom: 1px solid #4A4A4A;
    .img-brand{
      max-width: 81px;
      max-height: 40px;
    }
    .name-brand{
      font-size: 14px;
      font-weight: 600;
      text-transform: uppercase;
    }
    .type-family{
      font-size: 14px;
      font-weight: 600;
    }
    .average-text{
      font-size: 12px;
      font-weight: 600;
      color:#CECECE;
    }
  }
  .row-content{
    font-size: 14px;
  }
}

.modal-small-text{
  font-size: 12px;
}
.modal-big-text{
  font-size: 22px;
}
.border-in-modal{
  border: 1px solid #D9DFE8;
  border-radius: 10px;
}
.close-modal{
  position: absolute;
  right: 11px;
  top: 14px;
}
#tableHistorial{
  margin-top:10px;
  border-top: 10px solid #000;
  height: 289px;
  overflow-y: scroll;
  font-size: 14px;
  .header{
    &.row{
      margin:0;
      font-weight: 600;
      border-bottom: 2px solid #000;
    }
  }
  .container{
    padding: 0;
    .row{
      margin: 0;
    }
  }
}
</style>
